module.exports = __webpack_public_path__ + "static/media/skyed-logo.0523a9d7.png";